(() => {
  'use strict';

  const configElement = document.getElementById('xarcade-voice-agent-config');
  if (!configElement || document.getElementById('xarcade-voice-root')) return;

  let config;
  try {
    config = JSON.parse(configElement.textContent || '{}');
  } catch (error) {
    console.error('X-Arcade voice widget configuration is invalid.');
    return;
  }

  if (!config.sessionEndpoint || !config.agentId) return;

  const TARGET_SAMPLE_RATE = 24000;
  const MAX_EARLY_AUDIO_CHUNKS = 24;
  const MAX_SESSION_MS = 20 * 60 * 1000;
  const LAUNCHER_MINIMIZE_DELAY_MS = 6000;
  const CHATLING_WAIT_MS = 6000;
  const MAX_RECONNECT_ATTEMPTS = 3;
  const RECONNECT_BASE_DELAY_MS = 1000;
  const CONNECTION_READY_TIMEOUT_MS = 12000;
  const MICROPHONE_STORAGE_KEY = 'xarcadeVoiceMicrophoneId';
  const MIC_ECHO_GUARD_MS = 500;

  const root = document.createElement('div');
  root.id = 'xarcade-voice-root';
  root.innerHTML = `
    <button class="xav-launcher" type="button" aria-label="Open X-Arcade support options" aria-expanded="false" aria-controls="xav-choice-panel xav-panel" title="X-Arcade support">
      <svg aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M21 12a8 8 0 0 1-8 8H7l-4 2 1.4-4.2A9 9 0 1 1 21 12Z"></path>
        <rect x="10" y="7" width="4" height="7" rx="2"></rect>
        <path d="M8 12a4 4 0 0 0 8 0M12 16v2"></path>
      </svg>
      <span class="xav-launcher-label">Ask X-Arcade</span>
    </button>
    <section class="xav-choice-panel" id="xav-choice-panel" role="dialog" aria-labelledby="xav-choice-title" aria-modal="false" data-open="false">
      <header class="xav-choice-header">
        <div>
          <p class="xav-eyebrow">X-Arcade support</p>
          <h2 class="xav-title" id="xav-choice-title">How can we help?</h2>
        </div>
        <button class="xav-icon-button xav-choice-close" type="button" aria-label="Close support options">&times;</button>
      </header>
      <div class="xav-choice-body">
        <button class="xav-choice-button xav-choice-voice" type="button">
          <span class="xav-choice-icon" aria-hidden="true">&#127908;</span>
          <span><strong>Talk with voice</strong><small>Speak with the X-Arcade voice assistant</small></span>
        </button>
        <button class="xav-choice-button xav-choice-text" type="button">
          <span class="xav-choice-icon" aria-hidden="true">&#128172;</span>
          <span><strong>Chat by text</strong><small>Open the existing Chatling assistant</small></span>
        </button>
        <p class="xav-choice-status" role="status" aria-live="polite" hidden></p>
      </div>
    </section>
    <section class="xav-panel" id="xav-panel" role="dialog" aria-labelledby="xav-title" aria-modal="false" data-open="false">
      <header class="xav-header">
        <div class="xav-title-wrap">
          <p class="xav-eyebrow">Live voice help</p>
          <h2 class="xav-title" id="xav-title">Ask X-Arcade</h2>
        </div>
        <button class="xav-icon-button xav-panel-close" type="button" aria-label="Close voice assistant">&times;</button>
      </header>
      <div class="xav-body">
        <p class="xav-intro">Ask about products, compatibility, setup, troubleshooting, shipping, or an existing order.</p>
        <div class="xav-status" data-state="idle" role="status" aria-live="polite">
          <span class="xav-status-dot" aria-hidden="true"></span>
          <span class="xav-status-text">Ready when you are.</span>
        </div>
        <div class="xav-microphone-picker">
          <label class="xav-microphone-label" for="xav-microphone-select">Microphone</label>
          <div class="xav-microphone-row">
            <select class="xav-microphone-select" id="xav-microphone-select" aria-describedby="xav-microphone-help">
              <option value="recommended:auto">Recommended computer microphone</option>
            </select>
            <button class="xav-microphone-refresh" type="button">Find microphones</button>
          </div>
          <p class="xav-microphone-help" id="xav-microphone-help">Use Recommended to avoid iPhone or Continuity microphones when a computer microphone is available.</p>
        </div>
        <div class="xav-controls">
          <button class="xav-button xav-button-primary" type="button">Start voice conversation</button>
          <button class="xav-button xav-button-secondary" type="button" hidden>End conversation</button>
        </div>
        <div class="xav-transcript" aria-live="polite" data-has-content="false"></div>
        <p class="xav-privacy">Starting allows microphone access and sends audio to xAI so the assistant can respond. Do not share passwords or payment-card numbers. See our <a class="xav-link" href="${config.privacyUrl || '/policies/privacy-policy'}">privacy policy</a>.</p>
        <div class="xav-fallbacks">
          <span>Prefer another option?</span>
          <a class="xav-link" href="tel:${config.supportPhone || '+17753681356'}">Call ${config.supportPhoneDisplay || '(775) 368-1356'}</a>
          <a class="xav-link" href="mailto:${config.supportEmail || 'support@xgaming.com'}">Email support</a>
        </div>
      </div>
    </section>`;
  document.body.appendChild(root);
  document.documentElement.classList.add('xav-support-ready');

  const launcher = root.querySelector('.xav-launcher');
  const choicePanel = root.querySelector('.xav-choice-panel');
  const choiceCloseButton = root.querySelector('.xav-choice-close');
  const choiceVoiceButton = root.querySelector('.xav-choice-voice');
  const choiceTextButton = root.querySelector('.xav-choice-text');
  const choiceStatus = root.querySelector('.xav-choice-status');
  const panel = root.querySelector('.xav-panel');
  const closeButton = root.querySelector('.xav-panel-close');
  const startButton = root.querySelector('.xav-button-primary');
  const endButton = root.querySelector('.xav-button-secondary');
  const status = root.querySelector('.xav-status');
  const statusText = root.querySelector('.xav-status-text');
  const microphoneSelect = root.querySelector('.xav-microphone-select');
  const microphoneRefreshButton = root.querySelector('.xav-microphone-refresh');
  const microphoneHelp = root.querySelector('.xav-microphone-help');
  const transcript = root.querySelector('.xav-transcript');

  let websocket = null;
  let mediaStream = null;
  let audioContext = null;
  let mediaSource = null;
  let processor = null;
  let silentGain = null;
  let earlyAudio = [];
  let conversationReady = false;
  let sessionConfigurationSent = false;
  let sessionConfigured = false;
  let sessionTimer = null;
  let nextPlaybackTime = 0;
  let playbackSources = new Set();
  let assistantMessage = null;
  let userMessage = null;
  let endingByUser = false;
  let endingByServer = false;
  let launcherMinimizeTimer = null;
  let safePositionFrame = null;
  let safePositionObserver = null;
  let reconnectTimer = null;
  let connectionWatchdogTimer = null;
  let reconnectAttempts = 0;
  let reconnectInFlight = false;
  let sessionActive = false;
  let assistantSpeaking = false;
  let suppressAssistantAudio = false;
  let listeningResumeTimer = null;
  let savedMicrophoneId = '';
  try {
    savedMicrophoneId = window.localStorage.getItem(MICROPHONE_STORAGE_KEY) || '';
  } catch (error) {
    savedMicrophoneId = '';
  }

  const setStatus = (state, message) => {
    status.dataset.state = state;
    statusText.textContent = message;
  };

  const minimizeLauncher = () => {
    if (launcherMinimizeTimer) window.clearTimeout(launcherMinimizeTimer);
    launcherMinimizeTimer = null;
    launcher.classList.add('is-minimized');
    scheduleSafePosition();
  };

  const isVisiblePositioningElement = (element) => {
    if (!element || root.contains(element)) return false;
    const rect = element.getBoundingClientRect();
    if (
      rect.width < 12
      || rect.height < 12
      || rect.right <= 0
      || rect.bottom <= 0
      || rect.left >= document.documentElement.clientWidth
      || rect.top >= document.documentElement.clientHeight
    ) return false;

    let node = element;
    while (node && node !== document.documentElement) {
      const style = window.getComputedStyle(node);
      if (
        node.hidden
        || node.getAttribute('aria-hidden') === 'true'
        || style.display === 'none'
        || style.visibility === 'hidden'
        || Number.parseFloat(style.opacity || '1') < 0.05
        || style.pointerEvents === 'none'
      ) return false;
      node = node.parentElement;
    }
    return true;
  };

  const hasFloatingPositionContext = (element) => {
    let node = element;
    while (node && node !== document.documentElement) {
      const position = window.getComputedStyle(node).position;
      if (position === 'fixed') return true;
      if (position === 'sticky') {
        const rect = node.getBoundingClientRect();
        if (rect.bottom > document.documentElement.clientHeight - 180) return true;
      }
      node = node.parentElement;
    }
    return false;
  };

  const updateSafePosition = () => {
    safePositionFrame = null;
    const viewportWidth = document.documentElement.clientWidth;
    const viewportHeight = document.documentElement.clientHeight;
    const mobile = viewportWidth <= 520;
    const baseBottom = mobile ? 78 : 82;
    const rightOffset = mobile ? 14 : 20;
    const launcherRect = launcher.getBoundingClientRect();
    const launcherWidth = Math.max(56, launcherRect.width || 56);
    const launcherLeft = launcherRect.width
      ? launcherRect.left
      : viewportWidth - rightOffset - launcherWidth;
    const launcherRight = launcherRect.width
      ? launcherRect.right
      : viewportWidth - rightOffset;
    const gap = 12;
    let safeBottom = baseBottom;
    const candidates = new Set();

    document.querySelectorAll(
      '#scroll-to-top-button, .prod__sticky-atc, #PBarNextFrameWrapper, [class*="sticky-atc"], [class*="sticky_atc"]',
    ).forEach((element) => candidates.add(element));

    document.querySelectorAll('button, a, [role="button"], iframe').forEach((element) => {
      if (element.id === 'chtl-chat-icon-container') return;
      if (isVisiblePositioningElement(element) && hasFloatingPositionContext(element)) {
        candidates.add(element);
      }
    });

    candidates.forEach((element) => {
      if (!isVisiblePositioningElement(element)) return;
      const rect = element.getBoundingClientRect();
      if (rect.width > viewportWidth * 0.92 && rect.height > viewportHeight * 0.45) return;
      if (rect.bottom < viewportHeight * 0.55) return;
      const overlapsRightRail = rect.right + gap >= launcherLeft && rect.left - gap <= launcherRight;
      if (!overlapsRightRail) return;
      safeBottom = Math.max(safeBottom, Math.ceil(viewportHeight - rect.top + gap));
    });

    const maximumBottom = Math.max(baseBottom, viewportHeight - 180);
    safeBottom = Math.min(safeBottom, maximumBottom);
    root.style.setProperty('--xav-safe-bottom', `${safeBottom}px`);
    root.style.setProperty(
      '--xav-panel-bottom',
      `${safeBottom + Math.max(56, launcherRect.height || 56) + 10}px`,
    );
  };

  const scheduleSafePosition = () => {
    if (safePositionFrame !== null) return;
    safePositionFrame = window.requestAnimationFrame(updateSafePosition);
  };

  const updateLauncherExpanded = () => {
    const expanded = choicePanel.dataset.open === 'true' || panel.dataset.open === 'true';
    launcher.setAttribute('aria-expanded', expanded ? 'true' : 'false');
  };

  const setChoiceOpen = (open, restoreFocus = true) => {
    choicePanel.dataset.open = open ? 'true' : 'false';
    choiceStatus.hidden = true;
    choiceStatus.textContent = '';
    updateLauncherExpanded();
    if (open) {
      minimizeLauncher();
      choiceVoiceButton.focus();
    } else if (restoreFocus) {
      launcher.focus();
    }
  };

  const setPanelOpen = (open) => {
    if (open) setChoiceOpen(false, false);
    panel.dataset.open = open ? 'true' : 'false';
    updateLauncherExpanded();
    if (open) {
      minimizeLauncher();
      scheduleSafePosition();
      refreshMicrophoneChoices().catch(() => {});
      closeButton.focus();
    } else {
      launcher.focus();
    }
  };

  const getChatling = () => {
    if (window.Chatling && typeof window.Chatling.open === 'function') return window.Chatling;

    const legacyOpenButton = document.getElementById('chtl-open-chat-icon');
    if (legacyOpenButton && typeof legacyOpenButton.click === 'function') {
      return {
        open: () => legacyOpenButton.click(),
        hideChatIcon: () => {},
      };
    }

    return null;
  };

  const waitForChatling = () => new Promise((resolve) => {
    const existing = getChatling();
    if (existing) {
      resolve(existing);
      return;
    }

    const startedAt = Date.now();
    const poll = window.setInterval(() => {
      const chatling = getChatling();
      if (chatling || Date.now() - startedAt >= CHATLING_WAIT_MS) {
        window.clearInterval(poll);
        resolve(chatling);
      }
    }, 150);
  });

  const hideOriginalChatlingIcon = async () => {
    const chatling = await waitForChatling();
    if (chatling && typeof chatling.hideChatIcon === 'function') chatling.hideChatIcon();
  };

  const openTextChat = async () => {
    choiceTextButton.disabled = true;
    choiceStatus.hidden = false;
    choiceStatus.textContent = 'Opening text chat…';
    const chatling = await waitForChatling();
    choiceTextButton.disabled = false;

    if (!chatling) {
      choiceStatus.textContent = 'Text chat is still loading. Please try again in a moment.';
      return;
    }

    setChoiceOpen(false, false);
    chatling.open();
    if (typeof chatling.hideChatIcon === 'function') chatling.hideChatIcon();
  };

  const addMessage = (role, content) => {
    const line = document.createElement('p');
    line.className = 'xav-message';
    const label = document.createElement('strong');
    label.textContent = role === 'assistant' ? 'X-Arcade: ' : 'You: ';
    const text = document.createElement('span');
    text.textContent = content;
    line.append(label, text);
    transcript.appendChild(line);
    transcript.dataset.hasContent = 'true';
    transcript.scrollTop = transcript.scrollHeight;
    return text;
  };

  const stopPlayback = () => {
    playbackSources.forEach((source) => {
      try { source.stop(); } catch (error) { /* already stopped */ }
    });
    playbackSources.clear();
    nextPlaybackTime = audioContext ? audioContext.currentTime : 0;
  };

  const clearListeningResumeTimer = () => {
    if (listeningResumeTimer) window.clearTimeout(listeningResumeTimer);
    listeningResumeTimer = null;
  };

  const queueListeningStatus = () => {
    clearListeningResumeTimer();
    const playbackRemainingMs = audioContext
      ? Math.max(0, nextPlaybackTime - audioContext.currentTime) * 1000
      : 0;
    listeningResumeTimer = window.setTimeout(() => {
      listeningResumeTimer = null;
      if (sessionActive && !assistantSpeaking) setStatus('listening', 'Listening…');
    }, playbackRemainingMs + MIC_ECHO_GUARD_MS);
  };

  const base64ToFloat32 = (value) => {
    const binary = atob(value);
    const bytes = new Uint8Array(binary.length);
    for (let index = 0; index < binary.length; index += 1) {
      bytes[index] = binary.charCodeAt(index);
    }
    const pcm = new Int16Array(bytes.buffer);
    const output = new Float32Array(pcm.length);
    for (let index = 0; index < pcm.length; index += 1) {
      output[index] = pcm[index] / (pcm[index] < 0 ? 0x8000 : 0x7fff);
    }
    return output;
  };

  const playAudioChunk = (base64Audio) => {
    if (!audioContext) return;
    const samples = base64ToFloat32(base64Audio);
    const buffer = audioContext.createBuffer(1, samples.length, TARGET_SAMPLE_RATE);
    buffer.getChannelData(0).set(samples);
    const source = audioContext.createBufferSource();
    source.buffer = buffer;
    source.connect(audioContext.destination);
    const startAt = Math.max(audioContext.currentTime + 0.018, nextPlaybackTime);
    nextPlaybackTime = startAt + buffer.duration;
    playbackSources.add(source);
    source.onended = () => playbackSources.delete(source);
    source.start(startAt);
  };

  const resample = (input, sourceRate, targetRate) => {
    if (sourceRate === targetRate) return new Float32Array(input);
    const ratio = sourceRate / targetRate;
    const outputLength = Math.max(1, Math.round(input.length / ratio));
    const output = new Float32Array(outputLength);
    for (let index = 0; index < outputLength; index += 1) {
      const sourceIndex = index * ratio;
      const left = Math.floor(sourceIndex);
      const right = Math.min(left + 1, input.length - 1);
      const mix = sourceIndex - left;
      output[index] = input[left] * (1 - mix) + input[right] * mix;
    }
    return output;
  };

  const floatToBase64Pcm16 = (input) => {
    const pcm = new Int16Array(input.length);
    for (let index = 0; index < input.length; index += 1) {
      const sample = Math.max(-1, Math.min(1, input[index]));
      pcm[index] = sample < 0 ? sample * 0x8000 : sample * 0x7fff;
    }
    const bytes = new Uint8Array(pcm.buffer);
    let binary = '';
    const step = 0x8000;
    for (let index = 0; index < bytes.length; index += step) {
      binary += String.fromCharCode(...bytes.subarray(index, index + step));
    }
    return btoa(binary);
  };

  const send = (event) => {
    if (websocket && websocket.readyState === WebSocket.OPEN && conversationReady) {
      websocket.send(JSON.stringify(event));
      return true;
    }
    return false;
  };

  const flushEarlyAudio = () => {
    if (!conversationReady || !websocket || websocket.readyState !== WebSocket.OPEN) return;
    earlyAudio.forEach((audio) => websocket.send(JSON.stringify({
      type: 'input_audio_buffer.append',
      audio,
    })));
    earlyAudio = [];
  };

  const microphoneConstraints = (deviceId = '') => ({
    channelCount: 1,
    echoCancellation: true,
    noiseSuppression: true,
    autoGainControl: true,
    ...(deviceId ? { deviceId: { exact: deviceId } } : {}),
  });

  const saveMicrophoneId = (deviceId) => {
    savedMicrophoneId = deviceId || '';
    try {
      if (savedMicrophoneId) {
        window.localStorage.setItem(MICROPHONE_STORAGE_KEY, savedMicrophoneId);
      } else {
        window.localStorage.removeItem(MICROPHONE_STORAGE_KEY);
      }
    } catch (error) {
      // The selection still works for this page when storage is unavailable.
    }
  };

  const isContinuityMicrophone = (label) => /\biphone\b|\bipad\b|\bcontinuity\b|\bmobile\b|smartphone/i.test(label || '');

  const microphonePreferenceScore = (device) => {
    const label = device.label || '';
    if (!device.deviceId) return -10000;
    if (isContinuityMicrophone(label)) return -10000;
    if (/virtual|doubao|immersed|blackhole|loopback/i.test(label)) return -5000;

    let score = 100;
    if (/built[- ]?in|internal|macbook|microphone array|realtek|laptop/i.test(label)) score += 500;
    if (/usb|headset|external|studio|webcam/i.test(label)) score += 250;
    return score;
  };

  const chooseRecommendedMicrophoneId = (inputs) => {
    const ranked = inputs
      .map((device, index) => ({ device, index, score: microphonePreferenceScore(device) }))
      .filter((entry) => entry.score > 0)
      .sort((left, right) => right.score - left.score || left.index - right.index);
    return ranked[0] ? ranked[0].device.deviceId : '';
  };

  const updateMicrophoneHelp = () => {
    const selected = microphoneSelect.selectedOptions[0];
    if (microphoneSelect.value.startsWith('recommended:')) {
      const recommendedLabel = selected
        ? selected.textContent.replace(/^Recommended:\s*/, '')
        : 'computer microphone';
      microphoneHelp.textContent = `Recommended will use ${recommendedLabel} and avoid iPhone or Continuity microphones when possible.`;
      return;
    }
    if (microphoneSelect.value && selected) {
      microphoneHelp.textContent = `Selected: ${selected.textContent}. Your choice will be remembered on this browser.`;
      return;
    }
    microphoneHelp.textContent = 'Select Find microphones to choose the input you want.';
  };

  const renderMicrophoneChoices = (inputs) => {
    const currentValue = microphoneSelect.value;
    const preferredId = currentValue && !currentValue.startsWith('recommended:')
      ? currentValue
      : savedMicrophoneId;
    const labelledInputs = inputs.filter((device) => device.deviceId && device.label);
    const recommendedId = chooseRecommendedMicrophoneId(labelledInputs);
    const recommendedDevice = labelledInputs.find((device) => device.deviceId === recommendedId);
    const recommendedOption = document.createElement('option');
    recommendedOption.value = recommendedId ? `recommended:${recommendedId}` : 'recommended:auto';
    recommendedOption.textContent = recommendedDevice
      ? `Recommended: ${recommendedDevice.label.trim()}`
      : 'Recommended computer microphone';
    microphoneSelect.replaceChildren(recommendedOption);

    labelledInputs.forEach((device, index) => {
      const option = document.createElement('option');
      option.value = device.deviceId;
      option.textContent = device.label.trim() || `Microphone ${index + 1}`;
      microphoneSelect.appendChild(option);
    });

    if (preferredId && labelledInputs.some((device) => device.deviceId === preferredId)) {
      microphoneSelect.value = preferredId;
    } else {
      microphoneSelect.value = recommendedOption.value;
      if (preferredId && labelledInputs.length) saveMicrophoneId('');
    }

    updateMicrophoneHelp();
  };

  const refreshMicrophoneChoices = async ({ requestPermission = false } = {}) => {
    if (!navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices) return [];

    let devices = await navigator.mediaDevices.enumerateDevices();
    let inputs = devices.filter((device) => device.kind === 'audioinput');

    if (requestPermission && !inputs.some((device) => device.label)) {
      const permissionStream = await navigator.mediaDevices.getUserMedia({ audio: true });
      try {
        devices = await navigator.mediaDevices.enumerateDevices();
        inputs = devices.filter((device) => device.kind === 'audioinput');
      } finally {
        permissionStream.getTracks().forEach((track) => track.stop());
      }
    }

    renderMicrophoneChoices(inputs);
    return inputs;
  };

  const startMicrophone = async () => {
    const selectedValue = microphoneSelect.value;
    const recommendedSelectedId = selectedValue.startsWith('recommended:')
      ? selectedValue.slice('recommended:'.length)
      : '';
    const explicitlySelectedId = selectedValue && !selectedValue.startsWith('recommended:')
      ? selectedValue
      : savedMicrophoneId;
    const requestedDeviceId = recommendedSelectedId !== 'auto'
      ? (explicitlySelectedId || recommendedSelectedId)
      : explicitlySelectedId;

    if (requestedDeviceId) {
      try {
        mediaStream = await navigator.mediaDevices.getUserMedia({
          audio: microphoneConstraints(requestedDeviceId),
        });
      } catch (error) {
        if (!['NotFoundError', 'OverconstrainedError'].includes(error.name)) throw error;
        if (explicitlySelectedId) saveMicrophoneId('');
        microphoneSelect.value = 'recommended:auto';
      }
    }

    if (!mediaStream) {
      const initialStream = await navigator.mediaDevices.getUserMedia({
        audio: microphoneConstraints(),
      });
      const inputs = await refreshMicrophoneChoices();
      const recommendedId = chooseRecommendedMicrophoneId(inputs);

      if (recommendedId) {
        initialStream.getTracks().forEach((track) => track.stop());
        mediaStream = await navigator.mediaDevices.getUserMedia({
          audio: microphoneConstraints(recommendedId),
        });
      } else {
        mediaStream = initialStream;
      }
    }

    const activeTrack = mediaStream.getAudioTracks()[0];
    const activeLabel = activeTrack && activeTrack.label ? activeTrack.label : 'selected microphone';
    microphoneHelp.textContent = `Using ${activeLabel}. End the conversation to change it.`;
    microphoneSelect.disabled = true;
    microphoneRefreshButton.disabled = true;

    audioContext = new (window.AudioContext || window.webkitAudioContext)();
    if (audioContext.state === 'suspended') await audioContext.resume();
    nextPlaybackTime = audioContext.currentTime;

    mediaSource = audioContext.createMediaStreamSource(mediaStream);
    processor = audioContext.createScriptProcessor(4096, 1, 1);
    silentGain = audioContext.createGain();
    silentGain.gain.value = 0;
    mediaSource.connect(processor);
    processor.connect(silentGain);
    silentGain.connect(audioContext.destination);

    processor.onaudioprocess = (event) => {
      // Keep sending microphone audio during playback so server VAD can detect barge-in.
      const input = event.inputBuffer.getChannelData(0);
      const normalized = resample(input, audioContext.sampleRate, TARGET_SAMPLE_RATE);
      const audio = floatToBase64Pcm16(normalized);
      if (!send({ type: 'input_audio_buffer.append', audio })) {
        earlyAudio.push(audio);
        if (earlyAudio.length > MAX_EARLY_AUDIO_CHUNKS) earlyAudio.shift();
      }
    };
  };

  const stopMicrophone = () => {
    if (processor) {
      processor.onaudioprocess = null;
      processor.disconnect();
      processor = null;
    }
    if (mediaSource) {
      mediaSource.disconnect();
      mediaSource = null;
    }
    if (silentGain) {
      silentGain.disconnect();
      silentGain = null;
    }
    if (mediaStream) {
      mediaStream.getTracks().forEach((track) => track.stop());
      mediaStream = null;
    }
    microphoneSelect.disabled = false;
    microphoneRefreshButton.disabled = false;
    updateMicrophoneHelp();
  };

  const requestSession = () => fetch(config.sessionEndpoint, {
    method: 'POST',
    mode: 'cors',
    credentials: 'omit',
    cache: 'no-store',
    headers: {
      'Content-Type': 'application/json',
      'X-XArcade-Voice-Widget': '1',
    },
    body: '{}',
  }).then(async (response) => {
    const data = await response.json().catch(() => ({}));
    if (!response.ok || !data.client_secret || !data.client_secret.value) {
      throw new Error(data.error || 'Voice session could not be created.');
    }
    return data;
  });

  const serverEndEventTypes = new Set([
    'call.ended',
    'call.completed',
    'conversation.ended',
    'conversation.completed',
    'conversation.closed',
    'session.ended',
    'session.closed',
  ]);

  const eventSignalsServerEnd = (event) => {
    if (!event || typeof event !== 'object') return false;
    const eventType = typeof event.type === 'string' ? event.type.toLowerCase() : '';
    const item = event.item && typeof event.item === 'object' ? event.item : {};
    const toolName = [
      event.name,
      event.tool_name,
      item.name,
      item.tool_name,
    ].find((value) => typeof value === 'string') || '';

    return serverEndEventTypes.has(eventType)
      || /(?:^|[._-])end[_-]?call(?:[._-]|$)/i.test(toolName);
  };

  const closeSignalsServerEnd = (event) => {
    if (endingByServer) return true;
    if (!event) return false;
    if (event.code === 1000) return true;
    const reason = typeof event.reason === 'string'
      ? event.reason.trim().toLowerCase()
      : '';
    return /(?:idle|silence|inactivity|end[_ -]?call|call ended|conversation ended|session ended)/.test(reason);
  };

  const scheduleReconnect = () => {
    if (endingByUser || endingByServer || !sessionActive || reconnectTimer || reconnectInFlight) return;

    if (navigator.onLine === false) {
      setStatus('connecting', 'Internet connection lost. Waiting to reconnect…');
      return;
    }

    if (reconnectAttempts >= MAX_RECONNECT_ATTEMPTS) {
      endSession('The voice connection could not be restored. Please start again or contact support.');
      return;
    }

    reconnectAttempts += 1;
    const delay = RECONNECT_BASE_DELAY_MS * (2 ** (reconnectAttempts - 1));
    const attemptMessage = reconnectAttempts === 1
      ? 'Connection interrupted. Reconnecting…'
      : `Still reconnecting… (attempt ${reconnectAttempts} of ${MAX_RECONNECT_ATTEMPTS})`;
    setStatus('connecting', attemptMessage);

    reconnectTimer = window.setTimeout(async () => {
      reconnectTimer = null;
      if (endingByUser || endingByServer || !sessionActive) return;
      reconnectInFlight = true;
      try {
        await connectRealtime({ reconnecting: true });
      } catch (error) {
        reconnectInFlight = false;
        console.warn('X-Arcade voice reconnect attempt failed.');
        scheduleReconnect();
      }
    }, delay);
  };

  const connectRealtime = async ({ reconnecting = false } = {}) => {
    if (endingByUser || endingByServer || !sessionActive) return;

    conversationReady = false;
    sessionConfigurationSent = false;
    sessionConfigured = false;
    earlyAudio = [];

    if (reconnecting) {
      setStatus('connecting', `Reconnecting… (attempt ${reconnectAttempts} of ${MAX_RECONNECT_ATTEMPTS})`);
    }

    const session = await requestSession();
    if (endingByUser || endingByServer || !sessionActive) return;

    setStatus('connecting', reconnecting ? 'Restoring the voice connection…' : 'Connecting to X-Arcade…');

    const realtimeUrl = new URL(session.realtime_url || 'wss://api.x.ai/v1/realtime');
    realtimeUrl.searchParams.set('agent_id', session.agent_id || config.agentId);
    const socket = new WebSocket(realtimeUrl.toString(), [
      `xai-client-secret.${session.client_secret.value}`,
    ]);
    websocket = socket;

    if (connectionWatchdogTimer) window.clearTimeout(connectionWatchdogTimer);
    connectionWatchdogTimer = window.setTimeout(() => {
      connectionWatchdogTimer = null;
      if (!endingByUser && !endingByServer && sessionActive && websocket === socket && !sessionConfigured) {
        try { socket.close(4001, 'connection timeout'); } catch (error) { /* already closed */ }
      }
    }, CONNECTION_READY_TIMEOUT_MS);

    socket.onmessage = (message) => {
      try {
        handleServerEvent(JSON.parse(message.data));
      } catch (error) {
        console.error('X-Arcade voice event could not be read.');
      }
    };

    socket.onerror = () => {
      if (!endingByUser && !endingByServer && sessionActive) {
        setStatus('connecting', 'Connection interrupted. Reconnecting…');
      }
    };

    socket.onclose = (event) => {
      if (connectionWatchdogTimer) window.clearTimeout(connectionWatchdogTimer);
      connectionWatchdogTimer = null;
      const endedByServer = !endingByUser
        && sessionActive
        && closeSignalsServerEnd(event);
      if (websocket === socket) websocket = null;
      reconnectInFlight = false;

      if (endedByServer) {
        endSession('Conversation ended. You can start another whenever you like.');
        return;
      }

      if (!endingByUser && !endingByServer && sessionActive) scheduleReconnect();
    };
  };

  const handleServerEvent = (event) => {
    if (eventSignalsServerEnd(event)) endingByServer = true;

    if (event.type === 'conversation.created') {
      if (!sessionConfigurationSent) {
        sessionConfigurationSent = true;
        websocket.send(JSON.stringify({
          type: 'session.update',
          session: {
            turn_detection: {
              type: 'server_vad',
              threshold: 0.5,
              silence_duration_ms: 700,
              prefix_padding_ms: 300,
            },
            audio: {
              input: { format: { type: 'audio/pcm', rate: TARGET_SAMPLE_RATE } },
              output: { format: { type: 'audio/pcm', rate: TARGET_SAMPLE_RATE } },
            },
          },
        }));
        setStatus('connecting', 'Preparing the voice connection…');
      }
      return;
    }

    if (event.type === 'session.updated') {
      if (sessionConfigured) return;
      sessionConfigured = true;
      conversationReady = true;
      reconnectAttempts = 0;
      reconnectInFlight = false;
      if (connectionWatchdogTimer) window.clearTimeout(connectionWatchdogTimer);
      connectionWatchdogTimer = null;
      earlyAudio = [];
      assistantSpeaking = true;
      clearListeningResumeTimer();
      setStatus('speaking', 'X-Arcade is greeting you…');
      return;
    }

    if (event.type === 'response.created') {
      suppressAssistantAudio = false;
      assistantSpeaking = true;
      clearListeningResumeTimer();
      return;
    }

    if (event.type === 'input_audio_buffer.speech_started') {
      suppressAssistantAudio = true;
      assistantSpeaking = false;
      clearListeningResumeTimer();
      stopPlayback();
      assistantMessage = null;
      userMessage = null;
      setStatus('listening', 'Listening…');
      return;
    }

    if (event.type === 'input_audio_buffer.speech_stopped') {
      setStatus('thinking', 'Thinking…');
      return;
    }

    if (event.type === 'response.output_audio.delta' && event.delta) {
      if (suppressAssistantAudio) return;
      assistantSpeaking = true;
      clearListeningResumeTimer();
      setStatus('speaking', 'X-Arcade is speaking…');
      playAudioChunk(event.delta);
      return;
    }

    if (event.type === 'response.output_audio_transcript.delta' && event.delta) {
      if (!assistantMessage) assistantMessage = addMessage('assistant', '');
      assistantMessage.textContent += event.delta;
      transcript.scrollTop = transcript.scrollHeight;
      return;
    }

    if ((event.type === 'conversation.item.input_audio_transcription.updated'
      || event.type === 'conversation.item.input_audio_transcription.completed') && event.transcript) {
      if (!userMessage) userMessage = addMessage('user', '');
      userMessage.textContent = event.transcript;
      transcript.scrollTop = transcript.scrollHeight;
      return;
    }

    if ((event.type === 'conversation.item.created' || event.type === 'conversation.item.added') && event.item && event.item.role === 'user') {
      const content = Array.isArray(event.item.content) ? event.item.content : [];
      const audioItem = content.find((item) => item.type === 'input_audio' && item.transcript);
      if (audioItem && audioItem.transcript) {
        if (!userMessage) userMessage = addMessage('user', '');
        userMessage.textContent = audioItem.transcript;
      }
      return;
    }

    if (event.type === 'response.done') {
      const wasInterrupted = suppressAssistantAudio;
      suppressAssistantAudio = false;
      assistantSpeaking = false;
      assistantMessage = null;
      if (!wasInterrupted) queueListeningStatus();
      return;
    }

    if (event.type === 'response.cancelled' || event.type === 'response.failed') {
      const wasInterrupted = suppressAssistantAudio;
      suppressAssistantAudio = false;
      assistantSpeaking = false;
      if (!wasInterrupted) queueListeningStatus();
      return;
    }

    if (event.type === 'error') {
      console.error('X-Arcade voice session error', event.error && event.error.code ? event.error.code : 'unknown');
      setStatus('error', 'The voice assistant hit a problem. Please try again or contact support.');
    }
  };

  const endSession = async (message = 'Conversation ended. You can start another whenever you like.') => {
    endingByUser = true;
    endingByServer = false;
    sessionActive = false;
    assistantSpeaking = false;
    suppressAssistantAudio = false;
    clearListeningResumeTimer();
    if (sessionTimer) window.clearTimeout(sessionTimer);
    sessionTimer = null;
    if (reconnectTimer) window.clearTimeout(reconnectTimer);
    reconnectTimer = null;
    if (connectionWatchdogTimer) window.clearTimeout(connectionWatchdogTimer);
    connectionWatchdogTimer = null;
    reconnectAttempts = 0;
    reconnectInFlight = false;
    stopPlayback();
    stopMicrophone();
    const socket = websocket;
    websocket = null;
    if (socket) {
      try { socket.close(1000, 'user ended session'); } catch (error) { /* already closed */ }
    }
    if (audioContext) {
      try { await audioContext.close(); } catch (error) { /* already closed */ }
      audioContext = null;
    }
    earlyAudio = [];
    conversationReady = false;
    sessionConfigurationSent = false;
    sessionConfigured = false;
    assistantMessage = null;
    userMessage = null;
    startButton.hidden = false;
    startButton.disabled = false;
    endButton.hidden = true;
    setStatus('idle', message);
  };

  const startSession = async () => {
    if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia || !window.WebSocket) {
      setStatus('error', 'Voice conversations are not supported by this browser. Please call or email support.');
      return;
    }

    startButton.disabled = true;
    microphoneSelect.disabled = true;
    microphoneRefreshButton.disabled = true;
    endingByUser = false;
    endingByServer = false;
    sessionActive = true;
    assistantSpeaking = false;
    suppressAssistantAudio = false;
    clearListeningResumeTimer();
    reconnectAttempts = 0;
    reconnectInFlight = false;
    if (reconnectTimer) window.clearTimeout(reconnectTimer);
    reconnectTimer = null;
    if (connectionWatchdogTimer) window.clearTimeout(connectionWatchdogTimer);
    connectionWatchdogTimer = null;
    transcript.replaceChildren();
    transcript.dataset.hasContent = 'false';
    setStatus('connecting', 'Requesting microphone access…');

    try {
      await Promise.all([
        startMicrophone(),
        connectRealtime(),
      ]);

      startButton.hidden = true;
      startButton.disabled = false;
      endButton.hidden = false;
      sessionTimer = window.setTimeout(() => {
        endSession('This voice session ended after 20 minutes. Start again if you still need help.');
      }, MAX_SESSION_MS);
    } catch (error) {
      console.error('X-Arcade voice session could not start.');
      await endSession('The voice assistant could not start. Please allow microphone access, try again, or contact support.');
      setStatus('error', 'The voice assistant could not start. Please allow microphone access, try again, or contact support.');
    }
  };

  launcherMinimizeTimer = window.setTimeout(minimizeLauncher, LAUNCHER_MINIMIZE_DELAY_MS);
  hideOriginalChatlingIcon();
  scheduleSafePosition();
  window.setTimeout(scheduleSafePosition, 400);
  window.setTimeout(scheduleSafePosition, 1600);
  window.addEventListener('resize', scheduleSafePosition, { passive: true });
  window.addEventListener('orientationchange', scheduleSafePosition, { passive: true });
  window.addEventListener('scroll', scheduleSafePosition, { passive: true });
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', scheduleSafePosition, { passive: true });
    window.visualViewport.addEventListener('scroll', scheduleSafePosition, { passive: true });
  }
  if (typeof window.MutationObserver === 'function') {
    safePositionObserver = new window.MutationObserver((records) => {
      if (records.some((record) => !root.contains(record.target))) scheduleSafePosition();
    });
    safePositionObserver.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style', 'hidden', 'aria-hidden'],
    });
  }

  launcher.addEventListener('click', () => {
    minimizeLauncher();
    if (panel.dataset.open === 'true') {
      closeButton.click();
      return;
    }
    setChoiceOpen(choicePanel.dataset.open !== 'true');
  });
  choiceCloseButton.addEventListener('click', () => setChoiceOpen(false));
  choiceVoiceButton.addEventListener('click', () => setPanelOpen(true));
  choiceTextButton.addEventListener('click', openTextChat);
  microphoneSelect.addEventListener('change', () => {
    saveMicrophoneId(
      microphoneSelect.value.startsWith('recommended:') ? '' : microphoneSelect.value,
    );
    updateMicrophoneHelp();
  });
  microphoneRefreshButton.addEventListener('click', async () => {
    microphoneRefreshButton.disabled = true;
    microphoneRefreshButton.textContent = 'Loading…';
    microphoneHelp.textContent = 'Allow microphone access so this browser can show the available devices.';
    try {
      const inputs = await refreshMicrophoneChoices({ requestPermission: true });
      if (!inputs.some((device) => device.label)) {
        microphoneHelp.textContent = 'No named microphones are available yet. Check this site’s microphone permission and try again.';
      }
    } catch (error) {
      microphoneHelp.textContent = 'Microphone access was not allowed. You can try again or use your browser’s site settings.';
    } finally {
      microphoneRefreshButton.disabled = false;
      microphoneRefreshButton.textContent = 'Find microphones';
    }
  });
  if (navigator.mediaDevices && typeof navigator.mediaDevices.addEventListener === 'function') {
    navigator.mediaDevices.addEventListener('devicechange', () => {
      if (!sessionActive) refreshMicrophoneChoices().catch(() => {});
    });
  }
  closeButton.addEventListener('click', async () => {
    if (websocket || mediaStream) await endSession();
    setPanelOpen(false);
  });
  startButton.addEventListener('click', startSession);
  endButton.addEventListener('click', () => endSession());
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      if (panel.dataset.open === 'true') {
        closeButton.click();
      } else if (choicePanel.dataset.open === 'true') {
        setChoiceOpen(false);
      }
    }
  });
  window.addEventListener('offline', () => {
    if (sessionActive && !endingByUser && !endingByServer) {
      setStatus('connecting', 'Internet connection lost. Waiting to reconnect…');
    }
  });
  window.addEventListener('online', () => {
    if (
      sessionActive
      && !endingByUser
      && !endingByServer
      && (!websocket || websocket.readyState !== WebSocket.OPEN)
    ) {
      reconnectInFlight = false;
      scheduleReconnect();
    }
  });
  document.addEventListener('visibilitychange', () => {
    if (
      document.visibilityState === 'visible'
      && sessionActive
      && !endingByUser
      && !endingByServer
      && (!websocket || websocket.readyState === WebSocket.CLOSED)
    ) {
      reconnectInFlight = false;
      scheduleReconnect();
    }
  });
  window.addEventListener('pagehide', () => {
    window.removeEventListener('orientationchange', scheduleSafePosition);
    if (window.visualViewport) {
      window.visualViewport.removeEventListener('resize', scheduleSafePosition);
      window.visualViewport.removeEventListener('scroll', scheduleSafePosition);
    }
    if (safePositionObserver) safePositionObserver.disconnect();
    safePositionObserver = null;
    if (safePositionFrame !== null) window.cancelAnimationFrame(safePositionFrame);
    safePositionFrame = null;
    endingByUser = true;
    sessionActive = false;
    assistantSpeaking = false;
    suppressAssistantAudio = false;
    clearListeningResumeTimer();
    if (sessionTimer) window.clearTimeout(sessionTimer);
    if (reconnectTimer) window.clearTimeout(reconnectTimer);
    if (connectionWatchdogTimer) window.clearTimeout(connectionWatchdogTimer);
    sessionTimer = null;
    reconnectTimer = null;
    connectionWatchdogTimer = null;
    stopPlayback();
    stopMicrophone();
    const socket = websocket;
    websocket = null;
    if (socket) socket.close(1000, 'page hidden');
  });
})();
